import React, { useContext, useEffect, useMemo, useState } from "react";
import { Backdrop, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField, Typography } from "@mui/material";
import { API } from "../conf";
import { Context } from "../App";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Policy from "./verse-form-policy";
import Step1 from "./verse-form-step1";
import Step2 from "./verse-form-step2";
import Step3 from "./verse-form-step3";
import Step4 from "./verse-form-step4";
import FinalStep from "./verse-form-final-step";
import success_gif from '../asset/pictures/Successfully Done.gif'

export default function VerseForm(props) {
    const navigate = useNavigate()
    const [organisation, setOrganisation] = useState(JSON.parse(sessionStorage.getItem('eglise')))
    const [agent, setAgent] = useState(JSON.parse(sessionStorage.getItem('user')))
    const {updateConnect} = useContext(Context)
    const [load, setLoad] = useState(true)
    const [open, setOpen] = useState(false)
    const [eglises, setEglises] = useState([])
    const [egliseId, setEglise] = useState('')
    const [banqueComptes, setBanqueComptes] = useState([])
    const [dispoDates, setDispoDates] = useState([])
    const [currentStepIndex, setCurrentStepIndex] = useState(0)

    const [result, setResult] = useState()

    const [fedVerseType, setFedVerseType] = useState('')
    const [fedBanque, setFedBanque] = useState('')
    const [localVerseType, setLocalVerseType] = useState([])
    const [dateDons, setDate] = useState('')
    const [dons, setDons] = useState([])
    const [fedRepartition, setFedRepartition] = useState({especes:[{montant:'', count:0}], cheques:[], retrait:[{montant:'', count:0}], virement:{date:moment().format('yyyy-MM-DD'),montant:0,ref:''}})
    const [petiteCaisse, setPetiteCaisse] = useState([{montant:'', count:0}])
    const [banqueEglise, setBanqueEglise] = useState({especes:[{montant:'', count:0}], cheques:[]})

    const eglise = useMemo(()=>organisation&&!organisation.isFederation ? organisation : eglises.find(el=>el._id===egliseId), [egliseId, eglises, organisation])
    useEffect(()=>{
        if(currentStepIndex===1){
            setLoad(true)
            fetch(API.concat(`/dons/${eglise.number}/no_verse/dates`), {method:'GET', headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                
            }}).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        setDispoDates(json)
                    } 
                    setLoad(false)
                }
            })
        }
        else if (currentStepIndex===2) {
            setLoad(true)
            fetch(API.concat(`/dons/by/${JSON.stringify({eglise: eglise.number, is_preverse: false, date:dateDons})}`), {
                method:'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        if(!(json.length===dons.length&&json.every(d=>dons.some(don=>don._id===d._id)))){
                            setDons(json);
                            setFedBanque('')
                            setFedRepartition({especes:[{montant:'', count:0}], cheques:[], retrait:[{montant:'', count:0}], virement:{date:moment().format('yyyy-MM-DD'),montant:0,ref:''}})
                            setPetiteCaisse([{montant:'', count:0}])
                            setBanqueEglise({especes:[{montant:'', count:0}], cheques:[]})
                        }
                    } 
                    setLoad(false)
                }
            })
        }
    }, [currentStepIndex])

    const fed_part = useMemo(()=>dons?.reduce((tt,current)=>tt+current.dime+Math.round((current.offrande_globale*0.4+Number.EPSILON)*100)/100+current.offrande_spe_feam.reduce((to,off)=>to+off.montant,0),0), [dons])
    const local_part = useMemo(()=>dons?.reduce((tt,current)=>tt+current.offrande_globale-Math.round((current.offrande_globale*0.4+Number.EPSILON)*100)/100+current.offrande_spe_eglise.reduce((to,off)=>to+off.montant,0),0), [dons])
    const totalFedVerse = useMemo(()=>fedRepartition.especes.reduce((tt,es)=>tt+Number(es.montant)*es.count,0)+fedRepartition.cheques.reduce((tt,ch)=>tt+ch.montant,0)+fedRepartition.retrait.reduce((tt,es)=>tt+Number(es.montant)*es.count,0)+fedRepartition.virement.montant,[fedRepartition])
    const totalLocalRepartition = useMemo(()=>petiteCaisse.reduce((tt,es)=>tt+Number(es.montant)*es.count,0)+banqueEglise.especes.reduce((tt,es)=>tt+Number(es.montant)*es.count,0)+banqueEglise.cheques.reduce((tt,ch)=>tt+ch.montant,0),[petiteCaisse, banqueEglise])
    const restToRepart = useMemo(()=>dons.reduce((tt,don)=>tt+don.repartition.especes.reduce((t,es)=>t+es.montant*es.count,0)+don.repartition.cheques.reduce((t,ch)=>t+ch.montant,0),0)
        -fedRepartition.especes.reduce((tt,es)=>tt+es.montant*es.count,0)-fedRepartition.cheques.reduce((tt,ch)=>tt+ch.montant,0),[dons,fedRepartition])

    const steps = useMemo(() => [
        { component: <Policy />, disabled:!eglise, action: () => setCurrentStepIndex(old=>old+1) },
        { component: <Step1 {...{fedVerseType, setFedVerseType,localVerseType,setLocalVerseType,eglise,dispoDates,dateDons,setDate}}/>, disabled:fedVerseType===""||dateDons==='', action: () => setCurrentStepIndex(old=>old+1) },
        { component: <Step2 {...{dons, fed_part, local_part}}/>, disabled:fed_part+local_part<=0, action: () => setCurrentStepIndex(old=>old+1) },
        { component: <Step3 {...{eglise, dons, banqueComptes, fed_part, fedVerseType, fedBanque, setFedBanque, setFedRepartition, fedRepartition}}/>, disabled:totalFedVerse<fed_part, action: () => setCurrentStepIndex(old=>old+1) },//si plus d'espèces et de chèque passer l'étape 4
        { component: <Step4 {...{eglise, dons, localVerseType,fedRepartition,restToRepart,petiteCaisse, setPetiteCaisse,banqueEglise, setBanqueEglise}}/>, disabled:totalLocalRepartition<restToRepart, action: () => setCurrentStepIndex(old=>old+1) },
        { component: <FinalStep {...{fedRepartition,fedVerseType,fed_part,local_part,totalFedVerse,totalLocalRepartition,petiteCaisse,banqueEglise}} />, action: () => setOpen(true) },
    ], [eglise, dispoDates, fedVerseType, localVerseType, dateDons, dons, banqueComptes, fed_part, local_part,fedBanque,fedRepartition, totalFedVerse, restToRepart, petiteCaisse, banqueEglise, totalLocalRepartition]);
    const currentStep = useMemo(() => steps[currentStepIndex], [currentStepIndex, steps]);

    function handleSubmit() {
        setLoad(true); setOpen(false)
        const versement = {fedVerseType,dateDons,feam_banque:fedBanque,dons:dons.map(d=>d.num),
            fedRepartition:{...fedRepartition,especes:fedRepartition.especes.filter(es=>es.montant>0&&es.count>0),retrait:fedRepartition.retrait.filter(es=>es.montant>0&&es.count>0)},
            petiteCaisse:petiteCaisse.filter(es=>es.montant>0&&es.count>0),banqueEglise:{...banqueEglise, especes:banqueEglise.especes.filter(es=>es.montant>0&&es.count>0)}, eglise:eglise.number}
        fetch(API.concat(`/versements`), {method:'POST', headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            },body: JSON.stringify(versement)
        }).then(async response => {
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    setResult(<img src={success_gif} alt="succès" loading="eager" width={500} height={500}/>)
                    setTimeout(() => navigate('/'), 2500);
                } else {
                    setLoad(false)
                }
            }
        })
    }
    
    useEffect(()=>{
        if (organisation&&organisation.isFederation) {
            setLoad(true)
            fetch(API.concat(`/eglises/by/${JSON.stringify(agent.eglises?.length>0 ? {_id:{$in: agent.eglises}}:{isFederation: false, isUnion: false})}`), {
                method:'GET',
                headers:{
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async(response) => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json();
                        setEglises(json)
                        setLoad(false)
                    }
                }
            })
        }
    }, [organisation])

    function setEgliseId(eglise_id) {
        setEglise(old=>{
            if (old!==eglise_id) {
                setFedVerseType('')
                setLocalVerseType([])
                setDate('')
                setDons([])
                setFedRepartition({especes:[{montant:'', count:0}], cheques:[], retrait:[{montant:'', count:0}], virement:{date:'',montant:0,ref:''}})
                setPetiteCaisse([{montant:'', count:0}])
                setBanqueEglise({especes:[{montant:'', count:0}], cheques:[]})
            } 
            return eglise_id
        })
    }

    useEffect(()=>{
        setOrganisation(JSON.parse(sessionStorage.getItem('eglise')))
        setAgent(JSON.parse(sessionStorage.getItem('user')))
        fetch(API.concat('/comptes/federation/banque'), {method:'GET', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json();
                    setBanqueComptes(json)
                    setLoad(false)
                }
            }
        })
    },[])

    return(
        <Box display='flex' flex={1} flexDirection='column' style={{height:'100vh'}}>
            <Header/>
            <Typography variant="h4" align="center" marginTop={3} marginBottom={organisation&&organisation.isFederation?0:3}>Édition de bordereau de versement</Typography>
            {organisation&&organisation.isFederation&&<>{currentStepIndex===0?<TextField select size="small" label="église" sx={{alignSelf:'end',marginBottom:3, width:'25%', marginRight:3, minWidth:'200px'}} value={egliseId} onChange={e=>setEgliseId(e.target.value)}>
                {eglises.map(eglise=><MenuItem key={eglise._id} value={eglise._id}>{`${eglise.nom} - ${eglise.commune.toUpperCase()}`}</MenuItem>)}
            </TextField>:<Typography variant="h6" align="right" marginRight={5} marginBottom={3}>église {eglise.nom} - {eglise.commune.toUpperCase()}</Typography>}</>}
            <Box display='flex' flex={1} flexDirection='column' sx={{alignSelf:'center', width:'80%', border:'black 2px solid', padding:2, marginBottom:'5%', overflow:'auto'}}>
                <Box sx={{flexGrow:1, marginBottom:2}}>
                    {currentStep.component}
                </Box>
                <Box display='flex' justifyContent='space-between' alignItems='center'>
                    <Box>{currentStepIndex>0&&<Button variant="contained" onClick={()=>setCurrentStepIndex(old=> old-1)}>précédent</Button>}</Box>
                    <Button variant="contained" disabled={currentStep.disabled??false} onClick={currentStep.action}>{currentStepIndex === steps.length - 1 ? 'Terminer' : 'Continuer'}</Button>
                </Box>
            </Box>
            <Dialog open={open} onClose={()=>setOpen(false)}>
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>
                    <Typography>Vous confirmez l'enregistrement et la transmission au siège fédéral des informations renseignées précédemment?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>setOpen(false)}>Annuler</Button>
                    <Button onClick={handleSubmit}>Confirmer</Button>
                </DialogActions>
            </Dialog>
            <Backdrop open={load}>{result??<CircularProgress/>}</Backdrop>
        </Box>
    )
}